import React from 'react';

import { usePromoModel } from '../../../../contexts/PromoModelProvider';
import { usePromoCart } from '../../../../contexts/PromoCartProvider';
import { usePromoPresentation } from '../../../../contexts/PromoPresentationProvider';
import { ImageWrapper } from '../ImageWrapper/ImageWrapper';
import './ImagesContainer.scss';

export const ImagesContainer = () => {
  const { promoCartItemsObj, bogoSelectedProduct, freeItemInCart } = usePromoCart();
  const { anchorItemId, anchorItemImage, isBogo, isMsb } = usePromoModel();
  const promoCartItems = Object.values(promoCartItemsObj || {});
  const { isFirstProductPodVisible, promoListRef } = usePromoPresentation();
  const scrollToProductPod = (selectedItemId) => {
    if (selectedItemId) {
      let selectedPod;
      // Ignore first item
      for (let i = 1; i < promoListRef.children.length; i += 1) {
        selectedPod = promoListRef.children[i];
        if (selectedPod.id.includes(selectedItemId)) {
          if (selectedPod?.scrollIntoView) {
            selectedPod.scrollIntoView({ behavior: 'smooth' });
          } else {
            promoListRef.scrollTop = selectedPod.offsetTop - selectedPod.clientHeight;
          }
          return;
        }
      }
    }
  };

  const images = [];
  if (isBogo) {
    images.push({
      url: anchorItemImage,
      itemId: anchorItemId,
      message: 'This Item',
    });

    if (freeItemInCart) {
      images.push({
        url: freeItemInCart.image,
        itemId: freeItemInCart.itemId,
        message: 'FREE'
      });
    } else if (bogoSelectedProduct) {
      images.push({
        url: bogoSelectedProduct.media.image.url,
        itemId: bogoSelectedProduct.itemId,
        message: 'FREE'
      });
    } else {
      images.push({
        message: 'FREE'
      });
    }
  }

  if (isMsb) {
    promoCartItems.forEach(({ itemId, image, quantity }) => {
      images.push({
        url: image,
        itemId,
        quantity
      });
    });
  }

  return (
    <>
      {images.length > 0 ? (
        <div
          className={'images-container' + (!isFirstProductPodVisible && isMsb ? ' images-container--hide' : '')}
          data-testid="images-container"
        >
          {images.map((image, i) => (
            <React.Fragment key={image.title || `placeholder-${i}`}>
              <ImageWrapper
                image={image}
                isSuccessText={isBogo ? i !== 0 : null}
                showImageMessages={isBogo}
                cartQuantity={image.quantity}
                scrollToProductPod={() => scrollToProductPod(image.itemId)}
              />
              {isBogo && (i < images.length - 1) && (
                <span className="promo-image-seperator">+</span>
              )}
            </React.Fragment>
          ))}
        </div>
      ) : null}
    </>
  );
};

ImagesContainer.displayName = 'ImagesContainer';
